import React from "react";
import '../../css/g-header.css';

const GiganticHeader = (props) => {
  return (
    <div className="g-header">
      <h1>{props.headerTitle}</h1>
    </div>
  );
};

export default GiganticHeader;
